import { Component, input, output } from '@angular/core';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { Utils } from 'app/utils/utils';
@EnableClassTelemetry()
@Component({
  selector: 'app-sentiment-editor',
  templateUrl: './sentiment-editor.component.html',
  styleUrls: ['./sentiment-editor.component.scss'],
  standalone: false,
})
export class SentimentEditorComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  readonly projectId = input<string>();
  readonly sentimentScale = input<number>();
  readonly sentimentScore = input<number>();
  readonly sentimentValue = input<string>();
  readonly isLoading = input<boolean>(false);

  readonly cancel = output<void>();
  readonly save = output<{ score: number; value: string; comment: string }>();

  manualSentiment: { score: number; value: string };

  comment: string;

  hasChanges(): boolean {
    return (
      this.manualSentiment &&
      (this.manualSentiment.score !== Utils.roundNearest(this.sentimentScore()) ||
        this.manualSentiment.value !== this.sentimentValue())
    );
  }

  cancelSentiment() {
    this.cancel.emit();
  }

  saveSentiment() {
    this.save.emit({ ...this.manualSentiment, comment: this.comment });
  }
}
